window.VyborMotion = (() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const running = new Set();
  function play(element, frames, options = {}) {
    if (!element || preference.matches || !element.animate) return;
    for (const animation of running) {
      if (animation.effect?.target === element) animation.cancel();
    }
    const animation = element.animate(frames, {
      duration: 340, easing: 'cubic-bezier(.22,.7,.25,1)',
      fill: 'backwards', ...options
    });
    running.add(animation);
    animation.finished.catch(() => {}).finally(() => running.delete(animation));
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      play(entry.target, [{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'translateY(0)' }], {
        delay: Number(entry.target.dataset.motionOrder || 0) * 55
      });
    }
  }, { threshold: .08, rootMargin: '0px 0px -16px 0px' }) : null;
  function reveal(elements) {
    if (preference.matches || !observer) return;
    Array.from(elements).forEach((element, index) => {
      element.dataset.motionOrder = index % 4;
      observer.observe(element);
    });
  }
  function forget(elements) {
    Array.from(elements).forEach(element => observer?.unobserve(element));
  }
  function swapImage(image, src, alt, animationTarget = image) {
    image.alt = alt;
    if (image.getAttribute('src') === src) return;
    image.onload = () => {
      image.onload = null;
      play(animationTarget, [{ opacity: .45 }, { opacity: 1 }], { duration: 240 });
    };
    image.src = src;
  }
  function hero() {
    ['#hero-title', '#hero-description', '.hero-product-caption'].forEach((selector, index) => {
      play(document.querySelector(selector), [{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 280, delay: index * 35 });
    });
  }
  function dialog(element) {
    play(element, [{ opacity: 0, transform: 'translateY(10px) scale(.985)' }, { opacity: 1, transform: 'translateY(0) scale(1)' }], { duration: 220 });
  }
  preference.addEventListener('change', () => {
    if (!preference.matches) return;
    observer?.disconnect();
    for (const animation of running) animation.cancel();
    running.clear();
  });
  return Object.freeze({ reveal, forget, swapImage, hero, dialog });
})();
